import { all, call, put, takeEvery } from "redux-saga/effects";
import EmployeeMappingActionTypes from "../constants/employeeMapping-actionTypes";
import { getEmployeeMappingAccountsDataService, getEmployeeMappingDataService, getEmployeeMappingRolesDataService, getEmployeeMappingSitesDataService, updateUsermembershipDataService, updateUsermembershipDeleteService } from "../services/employeeMapping.service";
import EmployeeMappingURLs from "../constants/employeeMapping-urls";
import { updateUsermembershipDataSuccess, updateUsermembershipDeleteSuccess } from "../actions/employeeMapping.action";

function* fetchEmployeeMappingData({email}) {
    let items = {
      email:email,
    }
    try {
        const response = yield call(getEmployeeMappingDataService, EmployeeMappingURLs('GET_EMPLOYEEMAPPING_DATA',items));
        console.log("Fetching EmployeeMapping Data API is success");
        if (response.data) {
            yield put({
                type: EmployeeMappingActionTypes.EMPLOYEEMAPPING_DATA,
                payload: response.data,
            });
        }
    } catch (error) {
        console.log("Error while fetching EmployeeMapping Data Data");
    }
}

function* fetchEmployeeMappingRolesData(action) {
    try {
        const response = yield call(getEmployeeMappingRolesDataService, EmployeeMappingURLs('GET_EMPLOYEEMAPPING_ROLES'));
        console.log("Fetching EmployeeMapping Roles Data API is success");
        if (response.data) {
            yield put({
                type: EmployeeMappingActionTypes.EMPLOYEEMAPPING_ROLES,
                payload: response.data,
            });
        }
    } catch (error) {
        console.log("Error while fetching EmployeeMapping Roles Data");
    }
}

function* fetchEmployeeMappingAccountsData(action) {
    try {
        const response = yield call(getEmployeeMappingAccountsDataService, EmployeeMappingURLs('GET_EMPLOYEEMAPPING_ACCOUNTS'));
        console.log("Fetching EmployeeMapping Accounts Data API is success");
        if (response.data) {
            yield put({
                type: EmployeeMappingActionTypes.EMPLOYEEMAPPING_ACCOUNTS,
                payload: response.data,
            });
        }
    } catch (error) {
        console.log("Error while fetching EmployeeMapping Accounts Data");
    }
}

function* fetchEmployeeMappingSitesData(action) {
    try {
        const response = yield call(getEmployeeMappingSitesDataService, EmployeeMappingURLs('GET_EMPLOYEEMAPPING_SITES'));
        console.log("Fetching EmployeeMapping Sites Data API is success");
        if (response.data) {
            yield put({
                type: EmployeeMappingActionTypes.EMPLOYEEMAPPING_SITES,
                payload: response.data,
            });
        }
    } catch (error) {
        console.log("Error while fetching EmployeeMapping Sites Data");
    }
}

function* updateUserMembershipData({ payload: id ,callback}) {
      try {
          const response = yield call(updateUsermembershipDataService, EmployeeMappingURLs('UPDATE_USERMEMBERSHIP_DATA'), id);
          if (response.data) {
              yield put(
                updateUsermembershipDataSuccess()
              );
              console.log(response.data)
               if (callback && typeof callback === 'function') {
        callback(); 
      }
          }
      } catch (error) {
          console.log("Error while updating Usermembership Data", error);
      }
  }

  function* updateUserMembershipDelete({ payload: id ,callback}) {
      try {
          const response = yield call(updateUsermembershipDeleteService, EmployeeMappingURLs('UPDATE_USERMEMBERSHIP_DELETE'), id);
          if (response.data) {
              yield put(
                updateUsermembershipDeleteSuccess()
              );
              console.log(response.data)
               if (callback && typeof callback === 'function') {
        callback(); 
      }
          }
      } catch (error) {
          console.log("Error while updating Usermembership Delete", error);
      }
  }

function* watchGetRequest() {
    yield takeEvery(EmployeeMappingActionTypes.GET_EMPLOYEEMAPPING_DATA, fetchEmployeeMappingData);
    yield takeEvery(EmployeeMappingActionTypes.GET_EMPLOYEEMAPPING_ROLES, fetchEmployeeMappingRolesData);
    yield takeEvery(EmployeeMappingActionTypes.GET_EMPLOYEEMAPPING_ACCOUNTS, fetchEmployeeMappingAccountsData);
    yield takeEvery(EmployeeMappingActionTypes.GET_EMPLOYEEMAPPING_SITES, fetchEmployeeMappingSitesData);
    yield takeEvery(EmployeeMappingActionTypes.UPDATE_USERMEMBERSHIP_DATA_START, updateUserMembershipData);
    yield takeEvery(EmployeeMappingActionTypes.UPDATE_USERMEMBERSHIP_DELETE_START, updateUserMembershipDelete);

}

export default function* employeeMappingSagas() {
    yield all([watchGetRequest()]);
}